import React from 'react';
import IssuesWeSolve from '../components/IssuesWeSolve';

export default function IssuesWeSolvePage() {
  return (
    <div className="pt-16">
      <IssuesWeSolve />
    </div>
  );
}